'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Viewer = require('./Viewer');

var _Viewer2 = _interopRequireDefault(_Viewer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

exports["default"] = _Viewer2["default"];
module.exports = exports['default'];